// API設定管理ユーティリティ

class ApiConfig {
  constructor() {
    this.apiBaseUrl = null;
    this.apiUrlEndpoint = '/api/host_base_url.php'; // デフォルトのエンドポイント
  }

  // APIエンドポイントを設定
  setApiUrlEndpoint(endpoint) {
    this.apiUrlEndpoint = endpoint;
    // エンドポイントが変更されたらキャッシュをクリア
    this.apiBaseUrl = null;
  }

  // 現在のAPIエンドポイントを取得
  getApiUrlEndpoint() {
    return this.apiUrlEndpoint;
  }

  // APIベースURLを取得
  async getApiBaseUrl() {
    if (this.apiBaseUrl) {
      return this.apiBaseUrl;
    }

    try {
      const response = await fetch(this.apiUrlEndpoint, {
        method: 'POST',
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`API URL fetch failed: ${response.status}`);
      }

      const data = await response.json();
      if (data.host_name) {
        this.apiBaseUrl = data.host_name;
        return this.apiBaseUrl;
      } else {
        throw new Error('Invalid API URL response');
      }
    } catch (error) {
      console.error('API URL取得エラー:', error);
      // フォールバック: 空文字列を返す（相対パス使用）
      this.apiBaseUrl = '';
      return this.apiBaseUrl;
    }
  }

  // APIベースURLをクリア（再取得が必要な場合）
  clearApiBaseUrl() {
    this.apiBaseUrl = null;
  }
}

// シングルトンインスタンスをエクスポート
const apiConfig = new ApiConfig();
export default apiConfig;
